import React, { createContext, useContext, useState } from 'react';
import { api } from 'app';

const CustomOrdersUIContext = createContext();

export function useCustomOrdersUIContext() {
  return useContext(CustomOrdersUIContext);
}

export function CustomOrdersUIProvider({ children }) {
  const [isLoading, setIsLoading] = useState(true);
  const [data, setData] = useState([]);

  const fetchData = async query => {
    api
      .get(`/adminPanel/custom-orders${query}`)
      .then(response => {
        setData(response);
      })
      .catch(err => {
        console.log(err);
      });
  };

  const value = {
    fetchData,
    data,
    setData,
    isLoading,
    setIsLoading
  };

  return <CustomOrdersUIContext.Provider value={value}>{children}</CustomOrdersUIContext.Provider>;
}
